export default __webpack_public_path__ + "static/char-34-8b237d9aec2bf0a4ca0e52fbe184b417.webp";